import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, Loader2, Circle } from "lucide-react";

const STEPS = [
  { label: "Uploading Audio", desc: "Transferring engine sound file" },
  { label: "Validating Engine Sound", desc: "Checking frequency patterns" },
  { label: "Noise Cancellation", desc: "Filtering external sounds" },
  { label: "Extracting Raw Engine Sound", desc: "Isolating engine frequencies" },
  { label: "AI Analysis (Wisedrive Sound AI LLM)", desc: "Running proprietary diagnostic models" },
  { label: "Wisedrive Data Processing", desc: "Generating ratings, market analysis and predictions" },
];

export default function ProcessingSteps({ currentStep }) {
  return (
    <Card className="border border-slate-200 shadow-none rounded-sm overflow-hidden">
      <div className="border-b border-slate-200 p-4 bg-slate-50/50">
        <span className="text-sm font-bold uppercase tracking-wider text-slate-500">Processing Pipeline</span>
      </div>
      <CardContent className="p-5">
        <div className="space-y-4">
          {STEPS.map((step, i) => {
            const stepNum = i + 1;
            const isComplete = currentStep > stepNum;
            const isCurrent = currentStep === stepNum;
            const isPending = currentStep < stepNum;

            return (
              <div
                key={i}
                className={`flex items-center gap-4 p-4 rounded-sm transition-all duration-200 ${
                  isCurrent ? "bg-sky-50 border border-sky-200" :
                  isComplete ? "bg-emerald-50/50 border border-emerald-100" :
                  "bg-slate-50/50 border border-slate-100"
                }`}
                data-testid={`processing-step-${stepNum}`}
              >
                <div className="flex-shrink-0">
                  {isComplete && <CheckCircle size={22} className="text-emerald-500" />}
                  {isCurrent && <Loader2 size={22} className="text-sky-500 animate-spin" />}
                  {isPending && <Circle size={22} className="text-slate-300" />}
                </div>
                <div className="flex-1">
                  <p className={`text-base font-semibold ${
                    isCurrent ? "text-sky-700" : 
                    isComplete ? "text-emerald-700" : 
                    "text-slate-500"
                  }`}>
                    {step.label}
                  </p>
                  <p className={`text-sm ${
                    isCurrent ? "text-sky-600" : 
                    isComplete ? "text-emerald-600" : 
                    "text-slate-400"
                  }`}>
                    {step.desc}
                  </p>
                </div>
                {isCurrent && (
                  <span className="text-sm font-bold uppercase tracking-widest text-sky-500 animate-pulse">
                    Processing
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
